import { render, staticRenderFns } from "./SingleTask.vue?vue&type=template&id=0580da46&scoped=true&"
import script from "./SingleTask.vue?vue&type=script&lang=js&"
export * from "./SingleTask.vue?vue&type=script&lang=js&"
import style0 from "./SingleTask.vue?vue&type=style&index=0&id=0580da46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580da46",
  null
  
)

export default component.exports